module.exports = __webpack_public_path__ + "static/media/hrs-logo.ca9f461f.png";